import React from 'react';
import App from './App';

/**
 * SubdomainRouter: Renders the VEXL Corporate Gateway.
 */
const SubdomainRouter: React.FC = () => {
  return <App />;
};

export default SubdomainRouter;
